module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-bar"
  }, [_vm._v("\n  Minecraft Manager\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4cff1fe4"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/header/Left.vue
// module id = 165
// module chunks = 1